import { Div, Collection } from "@tblabs/truffle";
import { BasketItem } from "../../../Models/Basket/BasketItem";
import { CartItemBox } from "./CartItemBox";


export class BasketPreview extends Div
{
    constructor(items: Collection<BasketItem>)
    {
        super();

        this.Append(
            ...items.Map(x => new CartItemBox(x)),
        );
    }
}
